import {Injectable} from '@angular/core';
import {MatIconRegistry} from '@angular/material/icon';
import {DomSanitizer} from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class IconeService {

  constructor(
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer
  ) {
  }

  public registerIcons(): void {
    const iconList = [
      {name: 'bus-icon', url: 'assets/icons/keo-bus.svg'},
      {name: 'tram-icon', url: 'assets/icons/keo-tram.svg'},
      {name: 'bus-accessible-icon', url: 'assets/icons/keo-bus-accessible.svg'},
      {name: 'train-icon', url: 'assets/icons/keo-train.svg'},
      {name: 'parking-icon', url: 'assets/icons/keo-parking.svg'},
      {name: 'voiture-icon', url: 'assets/icons/keo-voiture.svg'},
      {name: 'velo-icon', url: 'assets/icons/keo-velo.svg'},
      {name: 'bateau-icon', url: 'assets/icons/keo-bateau.svg'},
      {name: 'twitter-icon', url: 'assets/icons/keo-twitter.svg'},
      {name: 'linkedin-icon', url: 'assets/icons/keo-linkedin.svg'},
      {name: 'youtube-icon', url: 'assets/icons/keo-youtube.svg'},
      {name: 'slideshare-icon', url: 'assets/icons/keo-slideshare.svg'},
    ];

    iconList.forEach(icon => {
      this.matIconRegistry.addSvgIcon(
        icon.name,
        this.domSanitizer.bypassSecurityTrustResourceUrl(icon.url)
      );
    });
  }
}
